import React, { useCallback } from 'react';

import { saveAs } from "file-saver";

import { Button } from '@chakra-ui/react';

import useTranslations from '../../../hooks/useTranslations';
import usePDFConversion from '../../../hooks/usePDFConversion';
import useFormatDate from '../../../hooks/useFormatDate';

import { ReportFragment } from '../../../graphql/generated/definitions';

export default function ReportDownloadAsPDF({ report }: { report: ReportFragment }) {
  const t = useTranslations();
  const { convert: convertReportToPDF, loading: convertReportToPDFLoading } =
    usePDFConversion();

  const filledAtFormatted = useFormatDate({
    date: report.filledAt,
    format: "long",
  });

  const generatePDF = useCallback(
    async (format) => {
      const blob = await convertReportToPDF({
        format,
        url: window.location.href,
        withCredentials: true,
      });

      saveAs(
        blob,
        t("reports.pdf.filename", {
          collaborator: report.review.collaborator.name,
          filledAt: filledAtFormatted,
        }) as string
      );
    },
    [convertReportToPDF, filledAtFormatted]
  );

  return (
    <Button
      size="sm"
      variant="outline"
      color="darkBrand"
      onClick={() => generatePDF("A4")}
      id="report-generate-pdf"
      isLoading={convertReportToPDFLoading}
    >
      {t("reports.shared.downloadAsPDF")}
    </Button>
  );
}